<template>
  <activity-dashboard :only-mine="false" />
</template>

<script>
import ActivityDashboard from './ActivityDashboard.vue'

export default {
  name: 'PidueciActivityPage',
  components: { ActivityDashboard }
}
</script>
